import { Badge } from '@/components/ui/badge';
import { ProcessObject } from './types';
import { RouterLink } from '@/components/link/Link';
import { ROUTES } from '@/constants';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

type Props = {
	processObject: ProcessObject;
};

const ProcessObjectExpandedRow = (props: Props) => {
	const { processObject } = props;

	return (
		<div className="py-6 space-y-6">
			<div className="flex flex-col gap-8">
				<div className="space-y-3">
					<div className="flex items-center gap-2">
						<div className="h-2 w-2 rounded-full bg-slate-900 dark:bg-slate-200"></div>
						<h4 className="font-semibold text-sm">
							Linked measurement groups ({processObject.relationsDetails.length})
						</h4>
					</div>
					<div className="flex flex-wrap gap-2">
						{processObject.relationsDetails.length > 0 ? (
							processObject.relationsDetails.map((rel, index) => (
								<Tooltip>
									<TooltipTrigger asChild>
										<Badge key={index} variant="default" className="text-xs" title={rel.mgName}>
											<RouterLink to={`${ROUTES.getMeasurementGroupURL(rel.mgId)}`}>
												{rel.mgId}
											</RouterLink>
										</Badge>
									</TooltipTrigger>
									<TooltipContent className="max-w-xs p-2">{rel.mgName}</TooltipContent>
								</Tooltip>
							))
						) : (
							<span className="text-sm text-muted-foreground italic">
								No measurement groups linked to this process object
							</span>
						)}
					</div>
				</div>

				<div className="space-y-3">
					<div className="flex items-center gap-2">
						<div className="h-2 w-2 rounded-full bg-slate-900 dark:bg-slate-200"></div>
						<h4 className="font-semibold text-sm">
							Linked indirect process objects ({processObject.relationsDetails.length})
						</h4>
					</div>
					<div className="flex flex-wrap gap-2">
						{processObject.relationsDetails.length > 0 ? (
							processObject.relationsDetails.map((rel, index) => {
								return (
									<Tooltip>
										<TooltipTrigger asChild>
											<Badge key={index} variant="default" className="text-xs" title={rel.mgName}>
												<RouterLink to={ROUTES.getMeasurementGroupURL(rel.mgId)}>
													{rel.ipoId}
												</RouterLink>
											</Badge>
										</TooltipTrigger>
										<TooltipContent className="max-w-xs p-2">{rel.mgName}</TooltipContent>
									</Tooltip>
								);
							})
						) : (
							<span className="text-sm text-muted-foreground italic">
								No indirect process objects linked to this process object
							</span>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProcessObjectExpandedRow;
